import { cx } from '@/lib/cx';
import styles from './GoldLine.module.css';

export interface GoldLineProps {
  /** `plain` linea sola · `diamond` rombo central · `star` destello central. */
  ornament?: 'none' | 'diamond' | 'star';
  /** Ancho maximo de la linea. `full` ocupa todo el contenedor. */
  width?: 'sm' | 'md' | 'full';
  className?: string;
}

/**
 * La linea dorada fina del sistema, con su remate central opcional.
 * Aparece en los 6 mockups bajo cejas y titulos. Es SVG + CSS, nunca imagen.
 */
export function GoldLine({ ornament = 'diamond', width = 'md', className }: GoldLineProps) {
  return (
    <div className={cx(styles.wrap, styles[width], className)} aria-hidden="true">
      <span className={styles.rule} />
      {ornament === 'diamond' ? (
        <svg className={styles.mark} viewBox="0 0 12 12" width="10" height="10" fill="currentColor">
          <path d="M6 0.6 8.6 6 6 11.4 3.4 6Z" />
        </svg>
      ) : null}
      {ornament === 'star' ? (
        <svg className={styles.mark} viewBox="0 0 24 24" width="14" height="14" fill="currentColor">
          <path d="M12 1.6c.7 5.6 4.8 9.7 10.4 10.4C16.8 12.7 12.7 16.8 12 22.4c-.7-5.6-4.8-9.7-10.4-10.4C7.2 11.3 11.3 7.2 12 1.6Z" />
        </svg>
      ) : null}
      <span className={styles.rule} />
    </div>
  );
}
